import { apiCall, } from '../common/apiCall.js';
import { allPermissions, } from '../user/Permission.js';
import { nonEmptyString, } from '../validator.js';
export const authModuleUrl = import.meta.url;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function loginRequestSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            email: nonEmptyString(),
            password: nonEmptyString(),
            token: nonEmptyString(),
            tan: nonEmptyString(),
        },
        required: [
            'email',
            'password',
        ],
    };
}
export async function login(baseUrl, props) {
    const response = await apiCall('POST', `${baseUrl}/api/auth/login`, props);
    return response;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function loginResponseSchema() {
    return {
        oneOf: [
            {
                type: 'object',
                additionalProperties: false,
                properties: {
                    status: {
                        const: 'success',
                    },
                    user: {
                        type: 'object',
                        additionalProperties: false,
                        properties: {
                            id: {
                                type: 'string',
                            },
                            permissions: {
                                type: 'array',
                                items: {
                                    type: 'string',
                                    enum: allPermissions,
                                },
                            },
                        },
                        required: [
                            'id',
                            'permissions',
                        ],
                    },
                },
                required: [
                    'status',
                    'user',
                ],
            },
            {
                type: 'object',
                additionalProperties: false,
                properties: {
                    status: {
                        const: 'tan required',
                    },
                    token: nonEmptyString(),
                },
                required: [
                    'status',
                    'token',
                ],
            },
            {
                type: 'object',
                additionalProperties: false,
                properties: {
                    status: {
                        const: 'error',
                    },
                    error: {
                        type: 'string',
                        enum: [
                            'invalid credentials',
                            'invalid tan',
                            'account locked',
                            'need verification',
                        ],
                    },
                },
                required: [
                    'status',
                    'error',
                ],
            },
        ],
    };
}
//# sourceMappingURL=AuthApi.js.map